import { UITemplateEditorModel } from "src/store/models/ui/understanding/templateEditor";

export const understandingModels = {
  templateEditor: UITemplateEditorModel,
};
